<template>
<div class="chapter">
<div class="inner_page">
<h1 class="author1" id="main-tp">Michael Phillips</h1>
<h1 class="title1">American Dreams Trilogy</h1>
<p class="title2"><em>Dream of Freedom</em></p>
<p class="title2A"><em>Dream of Life</em></p>
<p class="title2B"><em>Dream of Love</em></p>
<p class="ser"><img alt="images" src="images/logo.jpg"/></p>
<p class="title2A0">New York, 2018</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// main-tp.vue?681a3933